import * as api from '../../../requests.js'
import {setErrorToast} from '../../../actions'
import {
  SET_RECORD_DETAILS,
  SET_RECORD_NOTES,
} from '../RecordDetailsReducer'


export const addOrderNote = (note, fileNum) => {
    return (dispatch, getState) => {
      const {RecordNumber} = getState().record.recordDetails;
      const sourceTypes = getState().record.idEnums['SOURCE_TYPE'];
      api.SAVE_NOTE(sourceTypes['Certification'] || 810, RecordNumber, note, (note) => {
        api.FETCH_CERTIFICATION_RECORD_NOTES(
          fileNum,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      }, (err) => {
        dispatch(setErrorToast("Failed to Save Note"))
        console.error(err);
      })
    }
  }

  export const editOrderNote = (note, fileNum) => {
    return (dispatch, getState) => {
      api.EDIT_NOTE(note, () => {
        api.FETCH_CERTIFICATION_RECORD_NOTES(
          fileNum,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      }, (err) => {
        dispatch(setErrorToast("Failed to Edit Note"))
        console.error(err);
      })
    }
  }

  export const deleteOrderNote = (noteId, fileNum) => {
    return (dispatch, getState) => {
      api.DELETE_NOTE(noteId, () => {
        api.FETCH_CERTIFICATION_RECORD_NOTES(
          fileNum,
          (notes) => {
            dispatch({ type: SET_RECORD_NOTES, notes: notes })
          },
          (err) => console.error(err)
        )
      }, (err) => {
        dispatch(setErrorToast("Failed to Delete Note"))
        console.error(err);
      })
    }
  }

export const getOrderRecordData = (id) => {
    return (dispatch, getState) => {
      api.FETCH_CERTIFICATION_RECORD_DETAILS(
        id,
        (details) => {
          dispatch({ type: SET_RECORD_DETAILS, record: details })
          api.FETCH_CERTIFICATION_RECORD_NOTES(
            id,
            (notes) => {
              dispatch({ type: SET_RECORD_NOTES, notes: notes })
            },
            (err) => console.error(err)
          )
        },
        (err) => console.error(err)
      )
    }
}